// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.OrderStatusUpdateRequest */
/* istanbul ignore next */
@GandalfModel
export class OrderStatusUpdateRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Order is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	orderId!: number;

	@GandalfConstantDecorator(constants.OrderStatusCode)
	@GandalfValidator({ notNull: { message: 'Status is required' } })
	@GandalfProperty({ designType: constants.OrderStatusCode, isRequired: true })
	orderStatusCode!: constants.OrderStatusCode;

}
